export const percentageToDecimalNumber = (value: string | number): number =>
  parseFloat(value.toString().replace(',', '.')) / 100;
